export default __webpack_public_path__ + "static/media/progresive-budget.4387ead8.gif";